<nav #header #header1 class="fixed-top gtch"
    [ngClass]="{ 'gtch-scroll-hidden': scrolledPast && scrollingDown && !showMenu }">
    <div class="gtch-inner">
        <a class="gtch-logo" href="https://trailsgalapagos.com/" target="_blank">
            <img src="../assets/images/logos-header/gat.svg" alt="Galapagos Trails" />
        </a>

        <ul class="navbar-nav gtch-nav" [ngClass]="showMenu ? 'showMenu' : ''">
            <li class="nav-item menuItem gtch-has-submenu"
                [ngClass]="{'gtch-submenu-open': openSubmenu === 'packages'}">
                <a href="https://trailsgalapagos.com/groups-galapagos-trails/" target="_blank"
                    (click)="toggleSubmenu('packages', $event)">Packages &amp; Groups</a>
                <ul class="gtch-submenu">
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/charters/"
                            target="_blank">Charters</a></li>
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/packages-groups/"
                            target="_blank">All Packages</a></li>
                </ul>
            </li>
            <li class="nav-item menuItem gtch-has-submenu"
                [ngClass]="{'gtch-submenu-open': openSubmenu === 'daytours'}">
                <a href="https://trailsgalapagos.com/#islands" target="_blank"
                    (click)="toggleSubmenu('daytours', $event)">Day Tours</a>
                <ul class="gtch-submenu">
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/tours-santa-cruz/"
                            target="_blank">Tours Santa Cruz</a></li>
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/tours-isabela/"
                            target="_blank">Tours Isabela</a></li>
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/tours-san-cristobal/"
                            target="_blank">Tours San Cristobal</a></li>
                    <li class="nav-item menuItem gtch-has-submenu"
                        [ngClass]="{'gtch-submenu-open': openSubmenu === 'diving'}">
                        <a class="gtch-red" href="https://trailsgalapagos.com/diving-galapagos/" target="_blank"
                            (click)="toggleSubmenu('diving', $event)">Diving Galapagos</a>
                        <ul class="gtch-submenu">
                            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/discovery-dive/"
                                    target="_blank">Discovery Dive</a></li>
                            <li class="nav-item menuItem"><a
                                    href="https://trailsgalapagos.com/diving-seymour-mosquera/" target="_blank">Diving
                                    Seymour &amp; Mosquera</a></li>
                            <li class="nav-item menuItem"><a
                                    href="https://trailsgalapagos.com/diving-seymour-daphne/" target="_blank">Diving
                                    Seymour &amp; Daphne</a></li>
                            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/diving-gordons-rock/"
                                    target="_blank">Diving Gordon's Rock</a></li>
                            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/diving-kicker-rock/"
                                    target="_blank">Diving Kicker Rock</a></li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/cruises/" target="_blank">Cruises</a>
            </li>
            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/ferry-y-avioneta/"
                    target="_blank">Ferries &amp; Flights</a></li>
            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/galapagos-trip-planner/"
                    target="_blank">Trip Planner</a></li>
            <li class="nav-item menuItem gtch-has-submenu"
                [ngClass]="{'gtch-submenu-open': openSubmenu === 'tips'}">
                <a href="https://trailsgalapagos.com/blog/" target="_blank"
                    (click)="toggleSubmenu('tips', $event)">Travel Tips</a>
                <ul class="gtch-submenu">
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/faq/" target="_blank">FAQ</a>
                    </li>
                    <li class="nav-item menuItem"><a
                            href="https://trailsgalapagos.com/how-to-book-a-trip-to-the-galapagos-islands/"
                            target="_blank">How to Book a Trip to the Galapagos Islands</a></li>
                    <li class="nav-item menuItem"><a
                            href="https://trailsgalapagos.com/how-to-plan-the-perfect-galapagos-itinerary/"
                            target="_blank">How to Plan the Perfect Galapagos Itinerary: 5, 6, 8 and 10-Day
                            Routes</a></li>
                    <li class="nav-item menuItem"><a
                            href="https://trailsgalapagos.com/why-is-galapagos-unlike-anywhere-else-on-earth/"
                            target="_blank">Why Is Galapagos Unlike Anywhere Else on Earth?</a></li>
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/galapagos-wildlife-guide/"
                            target="_blank">Galapagos Wildlife Guide</a></li>
                    <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/blog/" target="_blank">Galapagos
                            Guide</a></li>
                </ul>
            </li>
            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/agencies-partners/"
                    target="_blank">Partners B2B</a></li>
            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/about-us/" target="_blank">About
                    Us</a></li>
            <li class="nav-item menuItem"><a href="https://trailsgalapagos.com/galapagos-science-access/"
                    target="_blank">Science Access</a></li>
        </ul>

        <div class="wishlist tooltip-container" *ngIf="companyParamsService.getFiltersInterest()">
            <app-heart-header></app-heart-header>
        </div>

        <button class="menuButton" type="button" (click)="renderMenu()" aria-label="Menu">
            <i class="fa fa-bars"></i>
        </button>
    </div>
</nav>
